import React from 'react';
import Grid from 'components/atoms/Grid';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function CustomizationSection() {
  return (
    <div>
      <span className="label customization-heading">Customization</span>
      <Grid xs={1} lg={2} colGap={10} rowGap={20}>
        <Form.Item
          label="Sub Heading"
          type="text"
          name="customization_subHeading"
          sm
          rules={[{ required: true, message: 'Enter material name' }]}>
          <Field />
        </Form.Item>
        <Form.Item
          label="Heading"
          type="text"
          name="customization_heading"
          sm
          rules={[{ required: true, message: 'Enter material description' }]}>
          <Field />
        </Form.Item>
      </Grid>
      <Form.Item
        label="Description"
        type="textarea"
        name="customization_description"
        sm
        rules={[{ required: true, message: 'Enter material description' }]}>
        <Field />
      </Form.Item>
    </div>
  );
}

export default CustomizationSection;
